import { render, staticRenderFns } from "./CustomerServiceDrawer.vue?vue&type=template&id=c6c3c742&scoped=true&"
import script from "./CustomerServiceDrawer.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceDrawer.vue?vue&type=style&index=0&id=c6c3c742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c3c742",
  null
  
)

export default component.exports